<template>
    <tbody v-if="plugins">
        <tr>
            <td colspan="2"><h2>Active Plugins ({{ Object.keys(plugins.active_plugins).length }})</h2></td>
        </tr>
        <tr v-for="plugin in plugins.active_plugins">
            <td width="35%">
                <a :href="plugin.plugin_uri" title="Visit plugin homepage" target="_blank">
                    {{ plugin.name }}
                </a>
            </td>

            <td v-if="plugin.author">
                <a :href="plugin.author_uri" target="_blank">{{ plugin.author }}</a>
                {{ plugin.version }}
            </td>
        </tr>
    </tbody>
</template>
<script>
export default {
    name: 'Plugins',

    props: ['plugins']
};
</script>
